module.exports = __webpack_public_path__ + "img/Cover_HW_19.568dc391.jpg";